import React from 'react'
import ReactDOM from 'react-dom/client'
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import App from './App'
import theme from './theme'
import './styles/index.css'
import './styles/storefront-bootstrap.css'
import './styles/materialm-dental.css'
import './styles/admin.css'
import './styles/admin-premium.css'
import './styles/site-layout.css'
import './styles/clinic-style.css'
import './styles/design-overhaul.css'
import './styles/premium-hero.css'
import './styles/favorites-drawer.css'
import './styles/favorites-animation.css'
import './styles/brand-logo.css'
import './styles/cart-page.css'
import './styles/login-page.css'
import './styles/sweetalert-overrides.css'
import './styles/ui-motion.css'
import './styles/cart-animation.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>,
)
